import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-73799b0c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "logo-box" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", null, "欢迎回来，", -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { style: { fontWeight: 700 } }, "量觉科技", -1); });
var _hoisted_6 = [
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
];
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "slogan" }, "诊疗更简单，医患更获益", -1); });
var _hoisted_9 = { class: "content" };
var _hoisted_10 = { class: "submit-btn" };
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("获取验证码");
var _hoisted_12 = { class: "overlay-wrapper" };
var _hoisted_13 = /*#__PURE__*/ _createTextVNode("加载中...");
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import request from "@/provide/fetch";
import { getQueryString } from "@/utils";
import { getDoctorsAccount } from "@/api";
import { Toast } from "vant";
import "vant/es/toast/style";
import { Notify } from "vant";
import "vant/es/notify/style";
export default /*#__PURE__*/ _defineComponent({
    __name: 'login',
    setup: function (__props) {
        var _this = this;
        var route = useRoute();
        var phoneIcon = require("../assets/phone.png");
        var loginVisible = ref(true);
        var doctorsAccount = ref([]);
        getDoctorsAccount().then(function (res) {
            if (res.code === 200) {
                doctorsAccount.value = res.data;
            }
        });
        // 路由跳转
        var goPage = function (userType) {
            switch (+userType) {
                case 1:
                    location.replace("/products");
                    break;
                case 2:
                    location.replace("/salesman-personal-center");
                    break;
                case 3:
                    location.replace("/doctor-list");
                    break;
            }
        };
        var getWxCode = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, request({
                            url: "/api/auth/url?url=" + encodeURIComponent(location.href.split("?")[0]),
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            location.replace(res.data);
                        }
                        else {
                            Toast(res.message || "系统错误-01");
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var getUserInfo = function (code) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, request({
                            url: "/api/auth/user_info",
                            params: {
                                code: code,
                            },
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            sessionStorage.setItem("openId", res.data.openid);
                            sessionStorage.setItem("headImgUrl", res.data.headImgUrl);
                            if (localStorage.getItem("userId")) {
                                location.replace("/?userType=" + localStorage.getItem("userType"));
                            }
                            else {
                                loginVisible.value = false;
                            }
                        }
                        else {
                            Toast(res.message || "系统错误-01");
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var code = getQueryString("code");
        var openId = sessionStorage.getItem("openId");
        if (!code && !openId) {
            getWxCode();
        }
        else {
            if (code && !sessionStorage.getItem("openId")) {
                getUserInfo(code);
            }
            else {
                if (localStorage.getItem("userId")) {
                    goPage(localStorage.getItem("userType"));
                }
                else {
                    loginVisible.value = false;
                }
            }
        }
        var router = useRouter();
        var tel = ref("");
        var loading = ref(false);
        var handleSummit = function (e, userType) {
            if (userType === void 0) { userType = localStorage.getItem("userType") || 1; }
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (!tel.value) {
                        return [2 /*return*/, Notify("请填写手机号")];
                    }
                    if (!/1\d{10}/.test(tel.value)) {
                        return [2 /*return*/, Notify("请填写正确的手机号")];
                    }
                    loading.value = true;
                    if (userType === "2") {
                        if (!doctorsAccount.value) {
                            getDoctorsAccount().then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (res.code === 200) {
                                        doctorsAccount.value = res.data;
                                        if (doctorsAccount.value.includes(tel.value)) {
                                            localStorage.setItem("userType", "3");
                                        }
                                        goVerification();
                                    }
                                    return [2 /*return*/];
                                });
                            }); });
                        }
                        else {
                            if (doctorsAccount.value.includes(tel.value)) {
                                localStorage.setItem("userType", "3");
                            }
                            goVerification();
                        }
                    }
                    else {
                        goVerification();
                    }
                    return [2 /*return*/];
                });
            });
        };
        var goVerification = function () {
            router.push({
                path: "/verification-code",
                query: {
                    tel: tel.value,
                    userType: localStorage.getItem("userType"),
                },
            });
        };
        return function (_ctx, _cache) {
            var _component_Icon = _resolveComponent("Icon");
            var _component_van_field = _resolveComponent("van-field");
            var _component_van_cell_group = _resolveComponent("van-cell-group");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_loading = _resolveComponent("van-loading");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h2", {
                        style: _normalizeStyle({ fontSize: '0.34rem' })
                    }, "登录", 4),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            style: _normalizeStyle({ fontSize: '0.48rem', textAlign: 'left' })
                        }, _hoisted_6, 4),
                        _hoisted_7
                    ]),
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_van_cell_group, null, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_van_field, {
                                    modelValue: tel.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((tel).value = $event); }),
                                    type: "tel",
                                    maxlength: "11",
                                    placeholder: "请输入你的手机号",
                                    "left-icon": _unref(phoneIcon),
                                    style: _normalizeStyle({ border: '2px solid #EEEEEE', borderRadius: '0.24rem' })
                                }, {
                                    "left-icon": _withCtx(function () { return [
                                        _createVNode(_component_Icon, {
                                            name: _unref(phoneIcon),
                                            size: "0.48rem"
                                        }, null, 8, ["name"])
                                    ]; }),
                                    _: 1
                                }, 8, ["modelValue", "left-icon", "style"])
                            ]; }),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_van_button, {
                                loading: loading.value,
                                round: "",
                                block: "",
                                type: "primary",
                                color: "rgba(61,171,164,1)",
                                onClick: handleSummit
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_11
                                ]; }),
                                _: 1
                            }, 8, ["loading"])
                        ])
                    ])
                ], 512), [
                    [_vShow, !loginVisible.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_van_loading, {
                        color: "#0094ff",
                        size: "24px",
                        vertical: ""
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_13
                        ]; }),
                        _: 1
                    })
                ], 512), [
                    [_vShow, loginVisible.value]
                ])
            ], 64));
        };
    }
});
